module.exports = __webpack_public_path__ + "static/scale-model-of-cherry-blossom-park-in-gresham-oregon-e3e58130e2c7f6c0e53655f553e9b11c.png";